import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import themeGet from '@styled-system/theme-get';

import useResetPassword from './useResetPassword';
import Text from '../Text';
import { Button } from '../FormStyles';
import TextInput from '../FormStyles/TextInput';

const FormWrapper = styled.div`
  padding: 16px;
  width: 100%;

  ${themeGet('mediaQueries.forMediumUp')} {
    padding: 24px;
  }
`;

const XIcon = styled.i`
  cursor: pointer;
`;

XIcon.defaultProps = {
  className: "fa-light fa-circle-x"
}

const TextWrapper = styled.div`
  text-align: left;
  margin-top: -8px;
  margin-bottom: 16px;
`;

const Title = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const ButtonGroup = styled.div`
  text-align: right;
`;

const CancelButton = styled(Button)`
  margin: 0;
`;

const ResetButton = styled(Button)`
  margin: 0 0 0 8px;
`;

const SignIn = () => {
  const { t } = useTranslation('resetPassword');
  const {
    values,
    handleSubmit,
    handleChange,
    inputError,
    disabledSubmit,
    handleBlur,
  } = useResetPassword();

  return (
    <FormWrapper>
      <Title>
        <Text variant="h5">{t('resetPassword')}</Text>
        <XIcon alt="exit" onClick={() => Swal.clickCancel()} />
      </Title>
      <TextInput
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={inputError('email')}
        name="email"
        m="0 0 16px"
        label={t('email')}
        placeholder={t('enterEmail')}
      />
      <TextWrapper>
        <Text variant="small4" color="black.80">
          {t('info')}
        </Text>
      </TextWrapper>
      <ButtonGroup>
        <CancelButton variant="tertiary" onClick={() => Swal.clickCancel()}>
          {t('cancel')}
        </CancelButton>
        <ResetButton
          type="submit"
          variant="containedBlue"
          onClick={handleSubmit}
          disabled={disabledSubmit}
        >
          {t('reset')}
        </ResetButton>
      </ButtonGroup>
    </FormWrapper>
  );
};

export default SignIn;
